/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useContext } from "react";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import CircularProgress from '@mui/material/CircularProgress';
// import Switch from "@mui/material/Switch";
// import Grid from "@mui/material/Grid";
// import MuiLink from "@mui/material/Link";

// // @mui icons
// import FacebookIcon from "@mui/icons-material/Facebook";
// import GitHubIcon from "@mui/icons-material/GitHub";
// import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";


// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-capcex.png";

import { AuthContext } from "context/auth.context";
import { fetchLogin } from "network/service";
import { useNavigate } from "react-router-dom";
import { Password } from "@mui/icons-material";

function Basic() {
  const [rememberMe, setRememberMe] = useState(false);

  const { setLogin, setRole, setUserDoc } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  let navigate = useNavigate();

 

  function login() {
    setLoading(true);
    fetchLogin(email, pass)
      .then((resp) => {
        console.log(resp.data);
        setLogin(resp.data.token);
        window.localStorage.setItem("jwt",resp.data.token);
        setRole(resp.data.role.name);
        setUserDoc(resp.data);
        console.log("User Logged in");
        navigate("/dashboard");
        setLoading(false);
      })
      .catch((err) => {
        console.log("error")
        console.log(err);
        setError('error');
        setLoading(false);
        //Handle Failure notification **
      });
    console.log("Logging in");
  }/*  */
  
  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            CapEx Login
          </MDTypography>
        
        </MDBox>

        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput 
               
              type="email" 
              label="Login ID" 
              fullWidth
              value={email}
              onChange={(text) => {
                setEmail(text.target.value)
              }}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
              
              type="password" 
              label="Password" 
              fullWidth 
              value={pass}
              onChange={(text) => {
                setPass(text.target.value)
              }}
              />
              
            </MDBox>

             {/* Error Popup */}
      {error && (
        <div className="error-popup">
          <MDTypography variant="overline" fontWeight="small" color="error" mt={1}>
            Please enter correct Login ID/ Password
          </MDTypography>
          
        </div>
      )}
    
    {loading && (
        <div className="error-LINEAR">
            <CircularProgress />
          
        </div>
      )}
  

            {/* <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Remember me
              </MDTypography>
            </MDBox> */}

            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth  onClick={login}  disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
              </MDButton>
            </MDBox>
            {/* <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Don&apos;t have an account?{" "}
                <MDTypography
                  component={Link}
                  to="/authentication/sign-up"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Sign up
                </MDTypography>
              </MDTypography>
            </MDBox> */}
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
